import React from "react";
import { connect } from "react-redux";
import SideNav from "components/layout-components/SideNav";
import TopNav from "components/layout-components/TopNav";
import Loading from "components/shared-components/Loading";
import MobileNav from "components/layout-components/MobileNav";
import HeaderNav from "components/layout-components/HeaderNav";
import PageHeader from "components/layout-components/PageHeader";
import Footer from "components/layout-components/Footer";
import WhiteLabelWrapper from "components/shared-components/WhiteLabelWrapper";
import AppViews from "views/app-views";
import { Layout, Grid } from "antd";

import navigationConfig from "configs/NavigationConfig";
import {
  SIDE_NAV_WIDTH,
  SIDE_NAV_COLLAPSED_WIDTH,
  NAV_TYPE_SIDE,
  NAV_TYPE_TOP,
  DIR_RTL,
  DIR_LTR,
} from "constants/ThemeConstant";
import utils from "utils";
import { useThemeSwitcher } from "react-css-theme-switcher";
import { getWhiteLabelConfig } from "constants/WhiteLabelConfig";

const { Content } = Layout;
const { useBreakpoint } = Grid;

export const AppLayout = ({ navCollapsed, navType, location, direction }) => {
  const currentRouteInfo = utils.getRouteInfo(
    navigationConfig,
    location.pathname
  );
  const screens = utils.getBreakPoint(useBreakpoint());
  const isMobile = screens.length === 0 ? false : !screens.includes("lg");
  const isNavSide = navType === NAV_TYPE_SIDE;
  const isNavTop = navType === NAV_TYPE_TOP;

  // Get customer info from localStorage
  const customerInfo = localStorage.getItem("customer_info")
    ? JSON.parse(localStorage.getItem("customer_info"))
    : null;

    // Check if user is a Speakho user (customer_id = 2)
    // Get white label configuration based on customer ID
  const whiteLabelConfig = getWhiteLabelConfig(customerInfo?.id);

  const getLayoutGutter = () => {
    // Check if navigation elements should be shown based on white label config
    const showNavigation = whiteLabelConfig.showNavigation;
    
    if (isNavTop || isMobile || !showNavigation) {
      return 0;
    }
    return navCollapsed ? SIDE_NAV_COLLAPSED_WIDTH : SIDE_NAV_WIDTH;
  };

  const { status } = useThemeSwitcher();

  if (status === "loading") {
    return <Loading cover="page" />;
  }

  const getLayoutDirectionGutter = () => {
    if (direction === DIR_LTR) {
      return { paddingLeft: getLayoutGutter() };
    }
    if (direction === DIR_RTL) {
      return { paddingRight: getLayoutGutter() };
    }
    return { paddingLeft: getLayoutGutter() };
  };

  return (
    <Layout>
      <WhiteLabelWrapper element="header">
        <HeaderNav isMobile={isMobile} currentRouteInfo={currentRouteInfo} />
        {isNavTop && !isMobile && (
          <TopNav routeInfo={currentRouteInfo} />
        )}
      </WhiteLabelWrapper>
      <Layout className="app-container">
        <WhiteLabelWrapper element="sideNav">
          {isNavSide && !isMobile && (
            <SideNav routeInfo={currentRouteInfo} />
          )}
        </WhiteLabelWrapper>
        <Layout className="app-layout" style={getLayoutDirectionGutter()}>
          <div className={`app-content ${isNavTop ? "layout-top-nav" : ""}`}>
            <WhiteLabelWrapper element="header">
              <PageHeader
                display={currentRouteInfo?.breadcrumb}
                title={currentRouteInfo?.title}
              />
            </WhiteLabelWrapper>
            <Content>
              <AppViews />
            </Content>
          </div>
          <WhiteLabelWrapper element="footer">
            <Footer isMobile={isMobile} />
          </WhiteLabelWrapper>
        </Layout>
      </Layout>
      <WhiteLabelWrapper element="sideNav">
        {isMobile && <MobileNav />}
      </WhiteLabelWrapper>
    </Layout>
  );
};

const mapStateToProps = ({ theme }) => {
  const { navCollapsed, navType, locale } = theme;
  return { navCollapsed, navType, locale };
};

export default connect(mapStateToProps)(React.memo(AppLayout));
